import React from "react";
import ReactFlagsSelect from "react-flags-select";
import { useSelector, useDispatch } from "react-redux";
import { FaCalculator } from "react-icons/fa";
//console.log("src/components/Navbar.js");

const Navbar = () => {
  const init = useSelector((state) => state.init);
  const dispatch = useDispatch();
  // get all unique values
  function getUnique(items, value1) {
    return [...new Set(items.map((item) => item[value1]))];
  }
  //
  const sflag = init.lang;
  let flc = [];
  const fll = eval("init.flags[" + String(sflag) + "][1]");
  let fld = "";
  // get unique sizes
  let uflags = getUnique(init.flags, 0);
  // map to jsx
  uflags = uflags.map((item, index) => {
    switch (index) {
      case 0:
        flc[index] = "NL";
        if (sflag === index) {
          fld = "NL";
        }
        break;
      case 1:
        flc[index] = "GB";
        if (sflag === index) {
          fld = "GB";
        }
        break;
      case 2:
        flc[index] = "DE";
        if (sflag === index) {
          fld = "DE";
        }
        break;
      case 3:
        flc[index] = "FR";
        if (sflag === index) {
          fld = "FR";
        }
        break;
      default:
        flc[index] = "NL";
        fld = "NL";
        break;
    }
    return uflags;
  });

  return (
    <nav>
      <div className="nav-center">
        <div className="nav-container">
          <FaCalculator></FaCalculator>
        </div>
        <h3>{init.title}</h3>
        <ReactFlagsSelect
          countries={flc}
          customLabels={fll}
          defaultCountry={fld}
          showSelectedLabel={false}
          onSelect={(countryCode) =>
            dispatch({
              type: "CHG_LANG",
              evalue: countryCode,
            })
          }
        />
      </div>
    </nav>
  );
};

export default Navbar;
